import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChevronDown, Globe } from 'lucide-react';
import { Button } from '../ui/button.jsx';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '../ui/dropdown-menu.jsx';
import { languages } from '../../lib/i18n/languages.jsx';
import translations from '../../translations.json';
export const useLanguage = () => {
  const { i18n } = useTranslation();
  const languageCode = i18n.resolvedLanguage?.startsWith('en') ? 'en' : 'sv';
  return {
    languageCode, language: languageCode === 'en' ? '🇬🇧 English' : '🇸🇪 Svenska',
    setLanguage: (label) => { const code = label.includes('English') || label === 'en' ? 'en' : 'sv'; localStorage.setItem('appLanguage', code); i18n.changeLanguage(code); },
    t: (key) => translations[languageCode][key] ?? key,
  };
};
const LanguageSwitcher = () => {
    const { language, languageCode, setLanguage, t } = useLanguage();
    const displayName = languageCode === 'en' ? 'English' : 'Svenska';
    const availableLanguages = languages.filter(lang => `${lang.flag} ${lang.name}` !== language);
    return (<div className="flex items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="flex items-center gap-1.5" aria-label={t('lang.switcherLabel').replace('{language}', displayName)}>
            <Globe size={16} className="text-muted-foreground" aria-hidden="true"/>
            <span className="font-medium">{languageCode.toUpperCase()}</span>
            <ChevronDown size={16} aria-hidden="true"/>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          {availableLanguages.map((lang) => (<DropdownMenuItem key={lang.name} onClick={() => setLanguage(`${lang.flag} ${lang.name}`)}>
              <span className="mr-2 text-xs font-semibold text-muted-foreground">
                {lang.code.toUpperCase()}
              </span>
              {lang.name}
            </DropdownMenuItem>))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>);
};
export default LanguageSwitcher;
